import qs from 'qs';
import { message, Modal } from 'antd';
import CryptoJS from 'crypto-js';
import dayjs from 'dayjs';
import { cloneDeep } from 'lodash-es';
import store from '../store/store';
import nationCode from './nationCodeData';
import baseRootConfig from '../script/config';
import { _anly_seng_custom, _get_client_down_url } from '../store/Action';

let debounceTimer = null; // 函数防抖记录的定时器ID
//终端相关
const _$objectFn = {
  isArray: function (x) {
    return this.getType(x) === '[object Array]';
  },
  isObject: function (x) {
    return this.getType(x) === '[object Object]';
  },
  getType: function (x) {
    return Object.prototype.toString.call(x);
  },
  o2s: function (object) {
    var result = [];
    for (var i in object) {
      result.push(i + '=' + object[i]);
    }
    return result.join('&');
  },
};
const Util = {
  getNationCodeByWord: (word) => {
    let firstWord = '';
    let findArr = [];
    nationCode.map((item, index) => {
      firstWord = item.country_name.substr(0, 1);
      if (firstWord.toLowerCase() == word || firstWord.toUpperCase() == word) {
        findArr.push(item);
      }
      return null;
    });
    return [{ firstWord: word }].concat(findArr);
  },
  getAllNationCode: () => {
    const words = [
      'A',
      'B',
      'C',
      'D',
      'E',
      'F',
      'G',
      'H',
      'I',
      'J',
      'K',
      'L',
      'M',
      'N',
      'O',
      'P',
      'Q',
      'R',
      'S',
      'T',
      'U',
      'V',
      'W',
      'X',
      'Y',
      'z',
    ];
    let allNationCode = [];
    words.map((item, index) => {
      allNationCode.push(...Util.getNationCodeByWord(item));
      return null;
    });
    return allNationCode;
  },
  setCookie: (name, value, days = 365) => {
    let exp = new Date();
    exp.setTime(exp.getTime() + days * 24 * 60 * 60 * 1000);
    document.cookie =
      name + '=' + escape(value) + ';path=/;expires=' + exp.toGMTString();
  },
  readCookie: (name) => {
    let arr,
      reg = new RegExp('(^| )' + name + '=([^;]*)(;|$)');
    if ((arr = document.cookie.match(reg))) {
      return unescape(arr[2]);
    } else {
      return null;
    }
  },
  delCookie: (name) => {
    let cval = Util.readCookie(name);
    if (cval != null) {
      document.cookie = name + '=;path=/;expires=' + new Date(0).toGMTString();
    }
  },
  //是否安装了flash
  flashChecker: () => {
    let hasFlash = false;
    if (document.all) {
      let swf = new window.ActiveXObject('ShockwaveFlash.ShockwaveFlash');
      if (swf) {
        hasFlash = true;
      }
    } else if (navigator.plugins && navigator.plugins.length > 0) {
      let swf = navigator.plugins['Shockwave Flash'];
      if (swf) {
        hasFlash = true;
      }
    }
    return hasFlash;
  },
  //天、 时、 分、 秒
  formatDuring: (dateTimeStamp) => {
    if (!dateTimeStamp || isNaN(dateTimeStamp)) {
      dateTimeStamp = 0;
    }
    let days = parseInt(dateTimeStamp / (1000 * 60 * 60 * 24));
    let hours = parseInt(
      (dateTimeStamp % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
    );
    let minutes = parseInt((dateTimeStamp % (1000 * 60 * 60)) / (1000 * 60));
    let seconds = parseInt((dateTimeStamp % (1000 * 60)) / 1000);
    if (days >= 0 && days < 10) {
      days = '0' + days;
    }
    if (hours >= 0 && hours < 10) {
      hours = '0' + hours;
    }
    if (minutes >= 0 && minutes < 10) {
      minutes = '0' + minutes;
    }
    if (seconds >= 0 && seconds < 10) {
      seconds = '0' + seconds;
    }
    return {
      days,
      hours,
      minutes,
      seconds,
    };
  },
  //格式化日期
  dateFormat: (_time, _format) => {
    if (!_time) _time = +new Date();
    if (!_format) _format = 'YYYY-MM-DD';
    return dayjs(_time).format(_format);
  },
  //格式化日期
  transTime: (dateTimeStamp) => {
    let getDayPoint = function (time) {
      time.setMinutes(0);
      time.setSeconds(0);
      time.setMilliseconds(0);
      time.setHours(0);
      let today = time.getTime();
      time.setMonth(0);
      time.setDate(1);
      let yearDay = time.getTime();
      return [today, yearDay];
    };
    let check = getDayPoint(new Date());
    if (dateTimeStamp >= check[0]) {
      let diff = +new Date() - dateTimeStamp;
      if (diff < 1000 * 60) {
        return '刚刚';
      } else {
        return Util.dateFormat(dateTimeStamp, 'HH:mm');
      }
    } else if (dateTimeStamp >= check[1]) {
      return Util.dateFormat(dateTimeStamp, 'MM-DD HH:mm');
    } else {
      return Util.dateFormat(dateTimeStamp);
    }
  },
  //格式化间隔日期
  transDate: (dateTimeStamp) => {
    let ms = +new Date() - dateTimeStamp;
    if (ms < 60000) {
      return '刚刚';
    }
    let ss = 1000;
    let mi = ss * 60;
    let hh = mi * 60;
    let dd = hh * 24;
    let day = parseInt(ms / dd);
    let hour = parseInt((ms - day * dd) / hh);
    let minute = parseInt((ms - day * dd - hour * hh) / mi);
    if (day) {
      return day + '天前';
    } else if (hour) {
      return hour + '小时前';
    } else if (minute) {
      return minute + '分钟前';
    } else {
      return '刚刚';
    }
  },
  //表情处理
  buildEmoji: (text) => {
    const { rootConfig } = store.getState();
    /* eslint-disable no-useless-escape*/
    let re = /\[([^\]\[]*)\]/g;
    let matches = text.match(re) || [];
    for (let j = 0, len = matches.length; j < len; ++j) {
      if (rootConfig.emojiList['emoji'][matches[j]]) {
        text = text.replace(
          matches[j],
          '<img class="emoji" style="max-height:22px" src="/assets/emoji/' +
            rootConfig.emojiList['emoji'][matches[j]].file +
            '" />'
        );
      }
    }
    /* eslint-enable no-useless-escape*/
    return text;
  },
  //会话消息处理
  transSessionItem: (msg) => {
    if (!msg) return '';
    let text = '';
    let type = msg.type;
    if (!/text|image|file|audio|video|geo|custom|tip|notification/i.test(type))
      return '我向你发送一个文件';
    if (/(<br>)|(<br\s*\/>)/i.test(msg.text)) {
      text = msg.text.replace(/(<br>)|(<br\s*\/>)/g, '');
    }
    let content = null;
    if (type === 'custom' && msg.content) {
      content = JSON.parse(msg.content);
    }
    if (type === 'text') {
      if (
        (msg.text.indexOf('localhost') !== -1 ||
          msg.text.indexOf('http') !== -1) &&
        msg.text.indexOf('dsid=') !== -1 &&
        msg.text.indexOf('jnid=') !== -1
      ) {
        text = '一条资质名片消息';
      } else if (
        (msg.text.indexOf('localhost') !== -1 ||
          msg.text.indexOf('http') !== -1) &&
        msg.text.indexOf('dsid=') !== -1
      ) {
        text = '一条大神名片消息';
      } else if (
        (msg.text.indexOf('localhost') !== -1 ||
          msg.text.indexOf('http') !== -1) &&
        msg.text.indexOf('roomid=') !== -1
      ) {
        text = '一条聊天室邀请消息';
      } else if (msg?.custom?.action === '103-5') {
        // 工单回复消息
        text += msg.text;
      } else {
        text += Util.buildEmoji(msg.text);
      }

      // todo 2023.12.27 新增换行处理
      if (typeof text === 'string' && /\n/i.test(text)) {
        text = text.replace(/\n/g, '<br />');
      }
    } else if (type === 'image') {
      text += '[图片]';
    } else if (type === 'file') {
      text += '[文件]';
    } else if (type === 'audio') {
      text += '[语音]';
    } else if (type === 'custom' && content && content.type === 3) {
      text += '[贴图]';
    } else if (type === 'tip') {
      // todo 2022.07.28 新增 tip 类型
      text += msg.tip;
    } else {
      text += '[自定义消息]';
    }

    return text;
  },
  //数字格式化
  numberFormat: (num = 0, fractionDigits = 0) => {
    num = parseFloat(num).toFixed(fractionDigits);
    return num.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  },
  //图片地址处理
  transImgUrlToGame: (url) => {
    const { rootConfig } = store.getState();
    if (
      !url ||
      url.trim() === '' ||
      url === '/assets/img/icon-user.png' ||
      url.indexOf('/assets/') !== -1
    ) {
      return '';
    } else if (url.indexOf('http') !== -1 || url.indexOf('https') !== -1) {
      return url;
    } else {
      return `${rootConfig.prefix}${url}`;
    }
  },
  //图片地址处理
  transImgUrl: (url, size) => {
    const { rootConfig } = store.getState();
    if (!url || url.trim() === '' || url === '/assets/img/icon-user.png') {
      return '/assets/img/icon-user.png';
    } else if (url.indexOf('thirdqq.qlogo.cn') !== -1) {
      return `/assets/img/icon-user.png`;
    } else if (url.indexOf('http') !== -1 || url.indexOf('https') !== -1) {
      return url;
    } else if (url.indexOf('/assets/') !== -1) {
      return url;
    } else if (size && url.indexOf('.gif') == -1) {
      return `${rootConfig.prefix}${url}/${size}`;
    } else {
      return `${rootConfig.prefix}${url}`;
    }
  },
  //计算昵称长度
  calNickWidthLen: (nick) => {
    let lenWidth = 0;
    if (!nick || nick == '') {
      return lenWidth;
    }
    for (let i = 0; i < nick.toString().length; i++) {
      if (/.*[\u4e00-\u9fa5]+.*/.test(nick[i])) {
        lenWidth += 2;
      } else {
        lenWidth += 1;
      }
    }
    return lenWidth;
  },
  /**
   * 客户端交互
   * buss 方法名
   * parss 参数
   * cbn 回调方法名
   * cb 回调方法
   * notFoundCb 判断不在客户端或者异常时的回调 todo 22.03.30 为了不破坏原有的参数
   */
  $interface: (buss, pars, cbn, cb, notFoundCb = null) => {
    if (!buss) return;
    _$objectFn.isArray(pars) && (pars = pars.join('&'));
    _$objectFn.isObject(pars) && (pars = _$objectFn.o2s(pars));
    if (window.STMatrixAsyn) {
      window.Config[cbn] = cb;
      window.STMatrixAsyn.MatrixCommunicateAsyn(buss, pars || '', '', '');
    } else {
      notFoundCb && notFoundCb(null);
    }
  },
  //数字处理
  convertNum: (n, fixed = 0) => {
    if (!n || n == undefined) {
      return 0;
    }
    if (n < 1000) {
      return parseFloat(n).toFixed(fixed);
    } else if (n < 100000000) {
      const num = (n / 1000).toFixed(fixed);
      if (num < 10) {
        return num + 'k';
      }
      return (num / 10).toFixed(fixed) + 'w';
    } else {
      return (n / 1000000).toFixed(fixed) + 'M';
    }
  },
  //数字处理
  convertNumK: (n) => {
    if (!n || n == undefined) {
      return 0;
    }
    if (n < 1000) {
      return n;
    } else {
      return (n / 1000).toFixed(1) + 'k';
    }
  },
  //数字处理
  convertNumW: (n, fixed = 2) => {
    if (!n || n == undefined) {
      return 0;
    }
    if (n < 10000) {
      return n;
    } else {
      return (n / 10000).toFixed(fixed) + 'w';
    }
  },
  //将云信账号转换成UID
  $analyToUid: (account) => {
    if (!account) return account;
    if (account.toString().indexOf('nimanon') != -1) return account;
    return account.replace('wp_test_', '').replace('wp_', '');
  },
  //将uid转换成云信账号
  $analyToAccount: (uid) => {
    const { rootConfig } = store.getState();
    if (!uid) return null;
    if (uid.toString().indexOf('nimanon') != -1) return uid;
    if (!uid || uid.toString().indexOf('wp_') !== -1) return uid;
    if (rootConfig.env === 'production') {
      return `wp_${uid}`;
    } else {
      return `wp_test_${uid}`;
    }
  },
  // 将即构流 ID 转成 UID
  $remoteStreamToUid: (streamId) => {
    if (!streamId) return null;
    const arr = streamId.split('_');
    if (arr?.length && arr.length > 2) {
      return [arr[0], arr[1]];
    }
    return null;
  },
  // 游戏账号转 UID
  $gameToUid: (account) => {
    if (!account) return null;
    const arr = account.split('_');
    if (arr?.length) {
      return arr[0];
    }
    return null;
  },
  /**
   * 生日计算年龄
   * @param birthdayDate 日期 格式：YYYY-MM-DD
   */
  birthdayCalcAge: (birthdayDate) => {
    if (!birthdayDate || birthdayDate == null) {
      return null;
    }
    const birthday = new Date(birthdayDate);

    let ageDifMs = Util.getNowTime() - birthday.getTime();
    let ageDate = new Date(ageDifMs);
    return Math.abs(ageDate.getUTCFullYear() - 1970);
  },
  /**
   * 计算星座
   * @param date 日期
   * @returns {string} 对应的星座
   */
  calcConstellation: (date) => {
    if (!date) {
      return null;
    }
    // 星座映射关系
    const ConstellationList = [
      { id: 1, start: 120, end: 218, name: '水瓶座' },
      { id: 2, start: 219, end: 320, name: '双鱼座' },
      { id: 3, start: 321, end: 420, name: '白羊座' },
      { id: 4, start: 420, end: 520, name: '金牛座' },
      { id: 5, start: 521, end: 621, name: '双子座' },
      { id: 6, start: 622, end: 722, name: '巨蟹座' },
      { id: 7, start: 723, end: 822, name: '狮子座' },
      { id: 8, start: 823, end: 922, name: '处女座' },
      { id: 9, start: 923, end: 1023, name: '天秤座' },
      { id: 10, start: 1024, end: 1122, name: '天蝎座' },
      { id: 11, start: 1123, end: 1221, name: '射手座' },
      { id: 12, start: 1222, end: 119, name: '魔羯座' },
    ];

    const time = new Date(date);
    const month = time.getMonth() + 1;
    const day = time.getDate();
    const num = `${month}${day < 10 ? '0' + day : day}`;

    if (
      num >= ConstellationList[ConstellationList.length - 1].start ||
      num <= ConstellationList[ConstellationList.length - 1].end
    ) {
      return ConstellationList[ConstellationList.length - 1];
    }

    let obj = {};
    for (let i = 0; i < ConstellationList.length; i++) {
      const item = ConstellationList[i];
      if (num >= item.start && num <= item.end) {
        obj = item;
        break;
      }
    }
    return obj;
  },
  /**
   * 函数防抖
   * @param func function
   * @param delay number
   * @returns {Function}
   */
  debounce: (func, delay = 300) => {
    return (...reset) => {
      const args = reset;
      if (debounceTimer) {
        clearTimeout(debounceTimer);
        debounceTimer = null;
      }

      debounceTimer = setTimeout(() => {
        func.apply(this, args);
      }, delay);
    };
  },
  //字符截取
  cutStr: (str, len) => {
    if (str && str.length > len) {
      return str.substr(0, len) + '...';
    }
    return str;
  },
  //获取当前时间
  getNowTime: () => {
    return new Date().getTime() + (window?.ServiceTimeStamp || 0);
  },
  isMobileEnv: () => {
    let isMobile = false;
    let sUserAgent = navigator.userAgent.toLowerCase();
    let bIsIpad = sUserAgent.match(/ipad/i) == 'ipad';
    let bIsIphoneOs = sUserAgent.match(/iphone os/i) == 'iphone os';
    let bIsMidp = sUserAgent.match(/midp/i) == 'midp';
    let bIsUc7 = sUserAgent.match(/rv:1.2.3.4/i) == 'rv:1.2.3.4';
    let bIsUc = sUserAgent.match(/ucweb/i) == 'ucweb';
    let bIsAndroid = sUserAgent.match(/android/i) == 'android';
    let bIsCE = sUserAgent.match(/windows ce/i) == 'windows ce';
    let bIsWM = sUserAgent.match(/windows mobile/i) == 'windows mobile';
    if (
      bIsIpad ||
      bIsIphoneOs ||
      bIsMidp ||
      bIsUc7 ||
      bIsUc ||
      bIsAndroid ||
      bIsCE ||
      bIsWM
    ) {
      isMobile = true;
    }
    return isMobile;
  },
  getBrowserInfo: () => {
    var agent = navigator.userAgent.toLowerCase();
    var regStr_ff = /firefox\/[\d.]+/gi;
    var regStr_chrome = /chrome\/[\d.]+/gi;
    var regStr_saf = /safari\/[\d.]+/gi;
    var isOpera = agent.indexOf('opera') > -1;
    var isIE =
      agent.indexOf('compatible') > -1 &&
      agent.indexOf('msie') > -1 &&
      !isOpera;
    if (agent.indexOf('edge') > -1) {
      return {
        name: 'Edge',
        version: 0,
      };
    } else if (agent.indexOf('firefox') > 0) {
      return {
        name: 'firefox',
        version: agent
          .match(regStr_ff)
          .toString()
          .replace(/[^0-9.]/gi, ''),
      };
    } else if (agent.indexOf('chrome') > 0) {
      return {
        name: 'chrome',
        version: agent
          .match(regStr_chrome)
          .toString()
          .replace(/[^0-9.]/gi, ''),
      };
    } else if (agent.indexOf('safari') > 0) {
      return {
        name: 'safari',
        version: agent
          .match(regStr_saf)
          .toString()
          .replace(/[^0-9.]/gi, ''),
      };
    } else if (isIE) {
      var reIE = new RegExp('MSIE (\\d+\\.\\d+);');
      var isversion = reIE.test(navigator.userAgent);
      var fIEVersion = parseFloat(RegExp['$1']);
      return {
        name: 'ie',
        version: isversion ? fIEVersion : 6,
      };
    } else if (agent.match(/(trident)\/([\d.]+)/)) {
      return {
        name: 'ie',
        version: 11,
      };
    } else {
      return {
        name: 'ie',
        version: 6,
      };
    }
  },
  /**
   * 获取 URL 参数
   * @param param 需要获取的字段
   * */
  getParameters: (param) => {
    if (!param) return null;
    const search = window.location.search.replace('?', '');
    const json = qs.parse(search);

    return json ? json[param] : null;
  },
  /**
   * 生成随机数
   * @param min 最小值
   * @param max 最大值
   * @param fixed 保留几位小数 默认值0
   * */
  random: (min, max = null, fixed = 0) => {
    let random = Math.random() * min;
    if (max) {
      random = Math.random() * (max - min) + min;
    }
    const num = random.toFixed(fixed);
    return Number(num);
  },
  /**
   * 获取上报 SDK 获取 UUID
   * */
  getReportUuid: () => {
    return new Promise((resolve) => {
      if (window.ST_UUID) {
        resolve(window.ST_UUID);
      } else if (window.ST && window.ST.webTJ && window.ST.webTJ.getUuid) {
        window.ST.webTJ.getUuid((uuid) => {
          window.ST_UUID = uuid;
          resolve(uuid);
        });
      } else {
        resolve(null);
      }
    });
  },
  /**
   * 获取上报 SDK 相关的信息
   * @param key 需要获取的字段（默认 null）
   * @return null|string 返回对应的参数
   * */
  getReportParams: (key = null) => {
    if (window?.ST?.webTJ?.fillParams) {
      const info = window.ST.webTJ.fillParams({});
      if (!!key) {
        return info[key] || null;
      }
      return info;
    }
    return null;
  },
  // 校验手机号
  validationPhone: (phone, nationCode = '86', isShowMsg = true) => {
    const { rootConfig } = store.getState();
    let realPhoneNum, myreg;
    if (rootConfig.lang === 'zh_CN') {
      myreg = /^[1][3-9][0-9]{9}$/;
      realPhoneNum = phone;
    } else {
      myreg =
        /^((\+\d{1,3}(-| )?\(?\d\)?(-| )?\d{1,5})|(\(?\d{2,6}\)?))(-| )?(\d{3,4})(-| )?(\d{4})(( x| ext)\d{1,5}){0,1}$/;
      realPhoneNum = nationCode + phone;
    }
    if (!myreg.test(realPhoneNum)) {
      isShowMsg && message.error('请正确填写手机号码');
      return false;
    }
    return true;
  },
  // 手机号添加 * 号
  getPrivatePhone: (phone, nationCode = '86') => {
    if (!phone || !phone.length) return '';
    const { rootConfig } = store.getState();
    const len = phone.length;
    if (rootConfig.lang !== 'zh_CN' && nationCode !== '86') {
      // 海外地区
      return phone.replace(phone.substr(len - 5, 3), '***');
    } else {
      // 大陆地区
      return phone.replace(phone.substr(3, 4), '****');
    }
  },
  /**
   * 复制内容
   * @param value 需要复制的内容
   * @param callback 复制成功的回调函数
   * */
  copyLink: (value, callback = null) => {
    let input = document.createElement('input');
    input.value = value;
    document.body.appendChild(input);
    input.select();
    if (document.execCommand('copy')) {
      document.execCommand('copy');
      if (callback) {
        callback();
      } else {
        message.success('复制成功');
      }
    }
    document.body.removeChild(input);
  },
  // 合成 classnames
  classNames: (...args) => {
    function merge(...args) {
      const len = args.length;
      let classnames = [];
      for (let i = 0; i < len; i++) {
        const n = args[i];
        if (n != null && !!n) {
          if (typeof n === 'string' || typeof n === 'number') {
            classnames.push(n);
          } else if (typeof n === 'object') {
            if (Array.isArray(n)) {
              n.forEach((_n) => {
                if (typeof _n === 'object') {
                  classnames.push(...merge(_n));
                } else {
                  classnames.push(_n);
                }
              });
            } else {
              const ns = Object.keys(n).filter((_n) => !!n[_n] && _n);
              classnames.push(...ns);
            }
          }
        }
      }
      return classnames;
    }

    const classnames = [...new Set([...merge(...args)])];
    return classnames.length ? classnames.join(' ') : '';
  },
  // 延迟执行
  sleep: (delay = 300) => new Promise((resolve) => setTimeout(resolve, delay)),
  cryptoParamsCode: async (headers, params) => {
    const copyParams = cloneDeep(params);
    let code = null;
    const instance = await Util.getAssemblyInstance();
    if (instance?.exports) {
      const { xhrChatEncryption } = instance.exports;

      // 对象参数不参与
      Object.keys(copyParams).forEach((key) => {
        let value = copyParams[key];
        if (typeof value === 'string') {
          value = value.trim();
        }
        if (typeof value === 'object') delete copyParams[key];
        else if (value === '') delete copyParams[key];
        else if (value == null) delete copyParams[key];
      });
      const aSort = returnASCLLSort(copyParams);
      const parStr = qs.stringify(aSort, { skipNulls: true, encode: false });
      code = xhrChatEncryption(
        JSON.stringify(headers),
        parStr,
        process.env.CLIENT_ENV
      );
    }
    return code;
  },
  // 加载 wasm 文件
  getAssemblyInstance: () => {
    return new Promise(async (resolve, reject) => {
      if (window.WebAssembly) {
        if (!window.AsBind) {
          const module = await import('as-bind');
          window.AsBind = module;
        }
        if (!window.wasmBuffer) {
          window.wasmBuffer = fetch(
            '/assets/lib/wasm/release.wasm?v=' + baseRootConfig.vnum
          ).then((res) => res.arrayBuffer());
        }
        const importObject = {
          utils: {
            consoleLog: (msg) => console.log(msg),
            utilsCryptoMD5: (word) => CryptoJS.MD5(word).toString(),
            utilsCryptoUTF8: (str) => CryptoJS.enc.Utf8.parse(str),
            utilsCryptoAESDecrypt: (word, key) => {
              const decrypt = CryptoJS.AES.decrypt(
                word,
                CryptoJS.enc.Utf8.parse(key),
                {
                  mode: CryptoJS.mode.ECB,
                  padding: CryptoJS.pad.Pkcs7,
                }
              );
              return decrypt.toString(CryptoJS.enc.Utf8);
            },
          },
        };
        const asBindInstance = await window.AsBind.instantiate(
          window.wasmBuffer,
          importObject
        );
        resolve(asBindInstance);
      } else {
        console.warn('您的浏览器不支持加密方式');
        reject({ error: '请升级浏览器', code: 1 });
      }
    });
  },
  // 解密数据
  decryptContent: (word, url = null) => {
    return new Promise(async (resolve, reject) => {
      try {
        if (typeof word === 'string') {
          const instance = await Util.getAssemblyInstance();
          const { chatRoomTokenDecrypt } = instance.exports;
          let decrypt = chatRoomTokenDecrypt(word, process.env.CLIENT_ENV);
          if (decrypt) {
            let json = decrypt;
            if (Util.isJSONStr(decrypt)) {
              json = JSON.parse(json);
              if (json?.notDecrypt) {
                // 无需解密，wasm直接返回，需要判断
                resolve(json.data);
              } else {
                resolve(json);
              }
            } else {
              resolve(json);
            }
            if (process.env.CLIENT_ENV !== 'production') {
              console.info(url, cloneDeep(json));
            }
          } else {
            reject(`${url} 解析失败`);
          }
        } else {
          resolve(word);
        }
      } catch (err) {
        reject(err);
      }
    });
  },
  /**
   * N 个数之间去一个随机值
   * @param nums {Array} 需要取的值的数组
   * @return {index: number, val: Object} 返回随机值 index 随机数 val 数组中随机的内容
   * */
  randomChoose: (nums) => {
    const len = nums.length;
    if (!len) return 0;
    if (len === 1) return nums[0];
    const index = Util.random(0, len - 1, 0);
    return { index, val: nums[index] };
  },
  /**
   * 生成UUID
   * */
  getUUID: () => {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
      // eslint-disable-next-line no-mixed-operators
      const r = (Math.random() * 16) | 0,
        v = c == 'x' ? r : (r & 0x3) | 0x8;
      return v.toString(16);
    });
  },
  /**
   * 判断客户端版本
   * @param version {number} 希望达到得版本号
   * @return {boolean} true 大于指定版本； false 小于指定版本； web不判断版本，默认为true
   * */
  checkClientVersion: (version = 316) => {
    const { client } = store.getState();
    if (window.eleEvents) {
      const { clientInfo } = store.getState();
      let clientVersion = clientInfo?.version || null;
      if (clientVersion)
        clientVersion = parseInt(clientVersion.replace(/\./g, ''));
      return clientVersion >= version;
    } else if (client === 'PC') {
      return false;
    }
    return true;
  },
  /**
   * 版本过低，请升级客户端版本
   * @param isForce {boolean} 是否强制提醒升级
   * @param tip {string} 提示语
   * */
  curVersionIsUpdate: (
    isForce = false,
    tip = '音质服务已升级，请更新至最新的版本。',
    source
  ) => {
    const { rootConfig, client, clientInfo } = store.getState();
    const publicParams = {
      client: client,
      webVersion: rootConfig.version,
      pcVersion: clientInfo.version,
    };
    Modal.confirm({
      title: '提示',
      icon: null,
      closable: true,
      content: tip,
      className: 'daidai-confirm-style',
      cancelText: '返回',
      okText: '前往下载',
      centered: true,
      onOk: () => {
        return new Promise(async (resolve) => {
          const url = await _get_client_down_url();
          window.open(url);
          if (isForce) {
            window.location.href = `/index${window.location.search}`;
          }
          _anly_seng_custom(1507, {
            data: {
              version: publicParams.webVersion,
              electronVersion: publicParams.pcVersion,
              down: true,
              source: source || 'other',
            },
          });
          resolve();
        });
      },
      onCancel: () => {
        if (isForce) {
          window.location.href = `/index${window.location.search}`;
        }
        _anly_seng_custom(1507, {
          data: {
            version: publicParams.webVersion,
            electronVersion: publicParams.pcVersion,
            back: true,
            source: source || 'other',
          },
        });
      },
    });
  },
  /**
   * 保存 session
   * @param key string 需要保存的 session key
   * @param value string 需要保存的 session value
   * @param expires number 过期时间戳，默认30天
   * @param cusExpires timestamp 自定义过期时间
   * */
  setSession(key, value, expires = 30, cusExpires = null) {
    if (key?.toString && value.toString) {
      if (expires == null || !isNaN(expires)) {
        let expiresTime = Date.now() + expires * 24 * 60 * 60 * 1000;
        if (cusExpires) {
          expiresTime = cusExpires;
        }
        window.sessionStorage.setItem(key, `${value}|${expiresTime}`);
      } else {
        console.error(`sessionStorage expires is not number`);
      }
    } else {
      console.error(`sessionStorage setItem key or value is not string`);
    }
  },
  /**
   * 读取 session
   * @param key string 需要读取的 session key
   * @return value string | null
   * */
  readSession(key) {
    const value = window.sessionStorage.getItem(key);
    const arr = value?.split('|') || null;
    if (arr?.length) {
      const expires = arr[1];
      if (expires > Date.now()) {
        return { value: arr[0], expires: Number(arr?.[1] || 0) };
      } else {
        Util.delSession(key);
      }
    }

    return null;
  },
  /**
   * 删除 session
   * @param key string 需要删除的 session key
   * @return value string | null;
   * */
  delSession(key) {
    const value = window.sessionStorage.getItem(key);
    window.sessionStorage.removeItem(key);
    return value;
  },
  /**
   * 判断是否是 JSON 字符串
   * @param {string} str
   * @return {boolean};
   * */
  isJSONStr(str) {
    if (typeof str == 'string') {
      try {
        const obj = JSON.parse(str);
        return typeof obj === 'object';
      } catch (e) {
        console.error('===isJSONStr===', e);
        return false;
      }
    }
    return false;
  },
  /*
  * 判断 str 是否可以安全转成 json
  * */
  isSafeJsonStr(str) {
    try {
      JSON.parse(str);
      return true;
    } catch (e) {
      return false;
    }
  },
};

// ASCII 排序
function returnASCLLSort(obj) {
  let arr = Object.keys(obj);
  arr = arr.sort();
  const newObj = {};
  arr.forEach((n) => (newObj[n] = obj[n]));
  return newObj;
}

window.Util = Util;
window.Config = {};
window.JsHandleCallBack = function (json) {
  json = decodeURI(json);
  json = JSON.parse(json);
  if (!json) return;
  var re = json.result || {};
  if (re.cbfn && window.Config[re.cbfn]) {
    window.Config[re.cbfn](re.data);
  } else if (re.cbfn && window.Config['_' + re.cbfn]) {
    window.Config['_' + re.cbfn](re.data);
  }
};
export default Util;
